import React from "react";
import { observer } from "mobx-react-lite";
import { components } from "../../../../../api/spec";
import DropdownMenu, {
  DropdownIconType,
  MenuItem,
} from "../../shared/components/DropdownMenu";

interface GuestListItemProps {
  guest: components["schemas"]["EventAttendeeSummarySchema"];
  onRemoveGuestAction?: ((guestId: string) => void) | null;
  className?: string;
}

const GuestListItemComponent: React.FC<GuestListItemProps> = ({
  guest,
  onRemoveGuestAction,
  className = "",
}) => {
  const getStatusDisplay = (status: string) => {
    switch (status) {
      case "started":
        return {
          label: "Started",
          emoji: "✏️️",
          color: "text-white-400",
          bgColor: "bg-[#121212]",
        };
      case "completed":
        return {
          label: "Completed",
          emoji: "😇",
          color: "text-blue-400",
          bgColor: "bg-[#16212A]",
        };
      case "not_started":
        return {
          label: "Not started",
          emoji: "😔",
          color: "text-white-400",
          bgColor: "bg-[#121212]",
        };
      case "pending_review":
        return {
          label: "Pending review",
          emoji: "😔",
          color: "text-white-400",
          bgColor: "bg-[#121212]",
        };
      case "not_signed_up":
        return {
          label: "Not signed up",
          emoji: "❌",
          color: "text-white-400",
          bgColor: "bg-[#121212]",
        };
      default:
        return {
          label: "Unknown",
          emoji: "❓",
          color: "text-white-400",
          bgColor: "bg-[#121212]",
        };
    }
  };

  const statusDisplay = getStatusDisplay(guest.status);

  const menuItems: MenuItem[] = [];

  if (onRemoveGuestAction) {
    menuItems.push({
      label: "⛔️ Remove guest",
      onClick: () => onRemoveGuestAction(guest.guid || ""),
    });
  }

  return (
    <div
      className={`relative border-b py-2 border-white/10 last:border-b-0 ${className}`}
    >
      <div className="flex items-center justify-between space-x-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <h3 className="text-white font-md text-lg">{guest.full_name}</h3>
            <p className="text-white/60 text-sm">{guest.gender}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div
            className={`flex items-center gap-2 rounded-full px-3 py-1 ${statusDisplay.bgColor}`}
          >
            <span className={`text-sm font-medium ${statusDisplay.color}`}>
              {statusDisplay.label} {statusDisplay.emoji}
            </span>
          </div>

          {guest.num_connected && guest.num_connected > 0 ? (
            <div className="text-sm flex items-center gap-2 rounded-full px-3 py-1 bg-[#121212]">
              🔗 {guest.num_connected}
            </div>
          ) : null}

          {guest.num_notified && guest.num_notified > 0 ? (
            <div className="text-sm flex items-center gap-2 rounded-full px-3 py-1 bg-[#121212]">
              🔔 {guest.num_notified}
            </div>
          ) : null}

          {menuItems.length > 0 ? (
            <DropdownMenu
              menuItems={menuItems}
              iconType={DropdownIconType.CHEVRON}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

GuestListItemComponent.defaultProps = {
  className: "",
  onRemoveGuestAction: null,
};

const GuestListItem = observer(GuestListItemComponent);

export default GuestListItem;
